import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '../../../../../../node_modules/@angular/forms';
import {FormConfiguracionComponent} from './cmp-form-configuracion/form-configuracion.component';
import {LoadingModule} from '../../../../autenticacion/loadingScreen/loading.module';

@NgModule({
    declarations: [FormConfiguracionComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        LoadingModule
    ]
})
export class ConfiguracionModule {

}


// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/configuracion/configuracion.module.ts